import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EUserRole } from 'src/app/entities/user.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class DoctorSecretaryRoleGuard implements CanActivate {
  constructor(private authService: AuthService) {}
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
     return from(
       this.authService.loadUser().pipe(
         map(
           (user) => {
            
             return user.role == EUserRole.DOCTOR_SECRETARY;
           },
           (error) => false,
         ),
       ),
     );
   }
  
}
